<template>
  <div class="mainSection">
    <div class="container">
      <div class="interfaceGrid">
        <AllSettingItem
          icon="pages-settings-interface-web"
          :toName="'settingInterfaceWeb'"
          :text="'Web'"
          tooltip_disabled
        />
        <AllSettingItem
          icon="pages-settings-interface-mob"
          :toName="'settingInterfaceMob'"
          :text="'Mobile'"
          tooltip_disabled
        />
        <AllSettingItem
          icon="pages-settings-interface-mail"
          :toName="'settingInterfaceMail'"
          :text="'Mail'"
          tooltip_disabled
        />
      </div>
    </div>
  </div>
</template>

<script>
// import Interface from 'components/setting/interface/Interface'
import AllSettingItem from 'components/setting/AllSettingItem'
export default {
  name: 'settingInterface',
  components: { AllSettingItem },
}
</script>

<style lang="scss" scoped>
.interfaceGrid {
  display: grid;
  grid-template-columns: repeat(3, 280px);
  gap: 30px;
}
</style>
